




















import { Component, Prop, Vue } from "vue-property-decorator";
import GuideMask from "@/components/mask/guideMask.vue";

@Component({
  components: {
    GuideMask
  }
})
export default class FormLabel extends Vue {
  @Prop(String) label?: string; // label文本
  @Prop(String) tip?: string; // tip文本
  @Prop(String) guide?: string; // 引导图片地址

  /* -------------- data ------------- */
  guideMaskShow = false
  ASSETS_URL = process.env.VUE_APP_ASSETS_URL;

  /* -------------- methods ------------- */

  /* 关闭遮罩 */
  closeGuideMask () {
    this.guideMaskShow = false;
  }
}
